import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#1f7a57",
        secondary: "#0d4a36",
        accent: "#8fd6b5",
        success: "#1f7a57",
        info: "#2f6f5e",
        warning: "#c56a1a",
        error: "#c62828",
      },
    },
  },
});
